import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { setSavedNotifier, setUnauthenticatedHandler } from './api/client'
import { useToastStore } from './stores/toast'
import './styles.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia).use(router)

/**
 * 저장이 끝나면 화면 가운데에 알립니다.
 *
 * <p>통로가 스토어를 바로 부르지 않고 여기서 이어 주는 이유는 <b>서로 물고 무는 것</b>을
 * 피하기 위함입니다 — 스토어는 통로를 쓰고 통로는 스토어를 쓰면 어느 쪽이 먼저
 * 만들어질지 알 수 없습니다.</p>
 */
setSavedNotifier((message) => useToastStore(pinia).show(message))

/** 확인 시간이 지나면 처음 화면으로 돌려보냅니다. */
setUnauthenticatedHandler(() => {
  if (router.currentRoute.value.name !== 'find') void router.replace({ name: 'find' })
})

app.mount('#app')
